import { METRICS } from '../config/metrics';

export const getMetricStatus = (metric, value) => {
  if (value === null || value === undefined) return 'unknown';
  const config = METRICS[metric];
  if (!config) return 'unknown';
  
  if (value <= config.good) return 'good';
  if (value >= config.poor) return 'poor';
  return 'needs-improvement';
};

export const formatValue = (metric, value) => {
  if (value === null || value === undefined) return 'N/A';
  
  const numValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numValue)) return 'N/A';
  
  const config = METRICS[metric];
  if (!config) return String(numValue);
  
  if (config.unit === 'ms') {
    return numValue >= 1000 ? `${(numValue / 1000).toFixed(2)}s` : `${Math.round(numValue)}ms`;
  }
  if (config.unit === '') {
    return numValue.toFixed(3);
  }
  return `${numValue}${config.unit}`;
};

export const formatMetricValue = formatValue;

export const formatDate = (dateObj) => {
  if (!dateObj) return '';
  if (dateObj.year && dateObj.month && dateObj.day) {
    return `${dateObj.day}.${dateObj.month}.${dateObj.year}`;
  }
  if (typeof dateObj === 'string') {
    const d = new Date(dateObj);
    return d.toLocaleDateString('cs-CZ', { day: 'numeric', month: 'short', year: 'numeric' });
  }
  return '';
};

export const displayDomain = (origin) => {
  if (!origin) return '';
  try {
    return new URL(origin).hostname;
  } catch (e) {
    return origin.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }
};

export const formatNumber = (num, decimals = 0) => {
  if (num === null || num === undefined) return 'N/A';
  return Number(num).toLocaleString('cs-CZ', { 
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals 
  });
};

export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return 'N/A';
  return `${(value * 100).toFixed(decimals)}%`;
};

export const formatBytes = (bytes) => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ');
};

export const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

export const throttle = (func, limit) => {
  let inThrottle;
  return (...args) => {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
};

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      return true;
    } catch (e) {
      return false;
    } finally {
      document.body.removeChild(textArea);
    }
  }
};

export default {
  getMetricStatus,
  formatValue,
  formatMetricValue,
  formatDate,
  displayDomain,
  formatNumber,
  formatPercent,
  formatBytes,
  classNames,
  debounce,
  throttle,
  sleep,
  copyToClipboard
};
